import { useEffect } from 'react';
import OfflineNotice from '../../components/utility/OfflineNotice';

const SimpleLayout = ({ children }) => {
    useEffect(() => {
        const scripts = [
            /* { src: '../../assets/js/tabler.min-2.js?1740838744' } */
        ];

        const scriptElements = scripts.map(({ src }) => {
            const script = document.createElement('script');
            script.src = src;
            script.defer = true;
            document.body.appendChild(script);
            return script;
        });

        return () => {
            scriptElements.forEach((script) => {
                document.body.removeChild(script);
            });
        };
    }, []);

    return (
        <>
            <main>
                <OfflineNotice />
                {children}
            </main>
        </>
    );
};

export default SimpleLayout;
